import { useRef, useState } from 'react';

import Transition from 'react-transition-group/Transition';
import { useDeepCompareEffect } from 'react-use';

// import { sortByOrder } from "../../provider/utility"
import './styles.scss';

const animationDuration = 1000;
const textVisibleFor = 6000;

const additionalStyle = {
  transition: `all ${animationDuration}ms ease-out`,
};
const transitionStyles = {
  entering: { opacity: 0 },
  entered: { opacity: 1 },
  exiting: { opacity: 1 },
  exited: { opacity: 0 },
};

function InfoBar({ texts }) {
  const [selectedText, setSelectedText] = useState(0);
  // const textToDisplay = useRef('')
  const [visible, setVisible] = useState(false);
  const setVisibleTimeoutRef = useRef(null);
  const startCycleTimeoutRef = useRef(null);

  const clearTimeouts = () => {
    clearTimeout(setVisibleTimeoutRef.current);
    clearTimeout(startCycleTimeoutRef.current);
  };

  const setStartCycleTimeout = (time, reset = false) => {
    clearTimeout(startCycleTimeoutRef.current);
    startCycleTimeoutRef.current = setTimeout(() => startCycle(reset), time);
  };

  const setVisibleTimeout = (value) => {
    clearTimeout(setVisibleTimeoutRef.current);
    setVisibleTimeoutRef.current = setTimeout(
      () => setVisible(value),
      textVisibleFor,
    );
  };

  const onNewPage = () => {
    clearTimeouts();
    // setVisible(false)

    // setStartCycleTimeout(animationDuration, true)
    startCycle(true);
  };

  const startCycle = (reset = false) => {
    setVisible(true);
    texts?.length > 1 && setVisibleTimeout(false);
    reset
      ? setSelectedText(0)
      : setSelectedText(
          selectedText >= texts.length - 1 ? 0 : selectedText + 1,
        );
    // if ( texts && texts[selectedText]) {
    //     textToDisplay.current = texts[selectedText].text
    // }
  };

  useDeepCompareEffect(onNewPage, [texts]);

  const handleOnExited = () => {
    setStartCycleTimeout(animationDuration);
  };

  if (!texts || texts.length === 0) {
    return null;
  }

  const longestMessage = [...texts].sort(
    (a, b) => b.text.length - a.text.length,
  )[0];

  return (
    <div className="InfoBar-container">
      <p
        className="InfoBar-p"
        style={{
          opacity: '0',
          backgroundColor: longestMessage.bgColor,
          ...additionalStyle,
        }}
      >
        {' '}
        {longestMessage.text}{' '}
      </p>
      <div
        className="InfoBar-div"
        style={{
          ...additionalStyle,
          backgroundColor: texts[selectedText]?.bgColor || '#000000',
        }}
      >
        <Transition
          in={visible}
          timeout={animationDuration}
          onExited={handleOnExited}
        >
          {(state) => (
            <p
              style={{
                ...additionalStyle,
                ...transitionStyles[state],
                color: texts[selectedText]?.color || '#FFFFFF',
                fontWeight: '500',
              }}
              className="InfoBar-p"
            >
              {texts[selectedText]?.text}
              {/* {textToDisplay.current} */}
            </p>
          )}
        </Transition>
      </div>
    </div>
  );
}

export default InfoBar;
